import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SECONDS } from '@sequencehq/utils/dates'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const usePublishedQuote = () => {
  const ctx = useCubeContext()
  const { id } = ctx.queries.rawData.data.common
  const { isExpired, publishedAt } = ctx.queries.rawData.data.quote
  const hasBeenPublished = Boolean(publishedAt)
  const shouldLoadPublishedQuote = hasBeenPublished && !isExpired

  const { data, isPending } = useQuery(
    dashboard20240730Client.getPublishedQuote,
    { id },
    {
      refetchInterval: 5 * SECONDS,
      enabled: shouldLoadPublishedQuote
    }
  )

  return {
    data,
    isLoading: shouldLoadPublishedQuote && isPending
  }
}
